function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0 0 20 0 30 9.86842105 30 39.4736842 0 39.4736842"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-3",
  points: "0 0 20 0 30 9.86842105 30 39.4736842 15 39.4736842 0 39.4736842"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "google_form"
}, /*#__PURE__*/React.createElement("g", {
  id: "Mask",
  fill: "#774FC1",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0 0 20 0 30 9.86842105 30 40 0 40"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-Clipped"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "path-1"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  mask: "url(#mask-2)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(5.526316, 17.368421)",
  id: "Rectangle-path"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  fill: "#E8F5E9",
  fillRule: "nonzero",
  x: 5.3122807,
  y: 0,
  width: 13.0666667,
  height: 2.36842105
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#E8F5E9",
  fillRule: "nonzero",
  x: 5.3122807,
  y: 4.60526316,
  width: 13.0666667,
  height: 2.36842105
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#E8F5E9",
  fillRule: "nonzero",
  x: 5.3122807,
  y: 9.21052634,
  width: 13.0666667,
  height: 2.36842105
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#E8F5E9",
  fillRule: "nonzero",
  x: 0,
  y: 0,
  width: 2.36842105,
  height: 2.36842105
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#E8F5E9",
  fillRule: "nonzero",
  x: 0,
  y: 4.60526316,
  width: 2.36842105,
  height: 2.36842105
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#E8F5E9",
  fillRule: "nonzero",
  x: 0,
  y: 9.21052634,
  width: 2.36842105,
  height: 2.36842105
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Clipped"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-4",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-3"
})), /*#__PURE__*/React.createElement("g", {
  id: "path-1"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-path",
  fill: "#BEA6DE",
  fillRule: "nonzero",
  mask: "url(#mask-4)",
  x: 20,
  y: 0,
  width: 10,
  height: 9.86842105
}))));

var SvgGoogleForm = function SvgGoogleForm(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "40px",
    viewBox: "0 0 30 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoogleForm, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google_form.d9aeed10.svg";
export { ForwardRef as ReactComponent };